// extracted by mini-css-extract-plugin
export var modal = "_ib-0";